import { render } from "./Index.vue?vue&type=template&id=2cb422fb&scoped=true&ts=true"
import script from "./Index.vue?vue&type=script&lang=ts"
export * from "./Index.vue?vue&type=script&lang=ts"

import "./Index.vue?vue&type=style&index=0&id=2cb422fb&lang=scss&scoped=true"

import exportComponent from "C:\\work\\h5\\yulinxing\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cb422fb"]])

export default __exports__